<template>
  <div class="app-container dongfu-list">
    <div class="box-01">
      <div class="list">
        <h4>东府直流屏</h4>
        <el-table :data="deviceData28664" stripe border style="width: 100%">
          <el-table-column prop="monitorName" label="监控点名称">
          </el-table-column>
          <el-table-column label="监控点值">
            <template slot-scope="scope">
              <template
                v-if="scope.row.value == 'true' || scope.row.value == 'false'"
              >
                <template>
                  <span v-if="scope.row.value == 'true'"> 报警 </span>
                  <span v-else> 正常 </span>
                </template>
              </template>
              <span v-else>
                {{ (+scope.row.value).toFixed(2) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="box-02">
      <div class="box-02-1">
        <div class="list">
          <h4>东府-201高压仪表</h4>
          <el-table :data="deviceData28121" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="+scope.row.monitorType > 11064">
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 合位 </span>
                    <span v-else> 分位 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list">
          <h4>东府-221高压仪表</h4>
          <el-table :data="deviceData28123" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="+scope.row.monitorType > 11064">
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 合位 </span>
                    <span v-else> 分位 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list">
          <h4>东府-配电室</h4>
          <el-table :data="deviceData28663" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="+scope.row.monitorType > 11064">
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 合位 </span>
                    <span v-else> 分位 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list">
          <h4>东府-2#变温控器</h4>
          <el-table :data="deviceData29823" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="scope.row.monitorType === '11025'">
                    <span v-if="scope.row.value == 'true'"> 启动 </span>
                    <span v-else> 停止 </span>
                  </template>
                  <template v-else-if="scope.row.monitorType === '010004'">
                    <span v-if="scope.row.value == 'true'"> 故障 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else-if="scope.row.monitorType === '11028'">
                    <span v-if="scope.row.value == 'true'"> 跳闸 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="box-02-1">
        <div class="list">
          <h4>东府-211高压仪表</h4>
          <el-table :data="deviceData28122" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="+scope.row.monitorType > 11064">
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 合位 </span>
                    <span v-else> 分位 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list">
          <h4>东府-202高压仪表</h4>
          <el-table :data="deviceData28124" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="+scope.row.monitorType > 11064">
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 合位 </span>
                    <span v-else> 分位 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list">
          <h4>东府-1#变温控器</h4>
          <el-table :data="deviceData29822" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template v-if="scope.row.monitorType === '11025'">
                    <span v-if="scope.row.value == 'true'"> 启动 </span>
                    <span v-else> 停止 </span>
                  </template>
                  <template v-else-if="scope.row.monitorType === '010004'">
                    <span v-if="scope.row.value == 'true'"> 故障 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else-if="scope.row.monitorType === '11028'">
                    <span v-if="scope.row.value == 'true'"> 跳闸 </span>
                    <span v-else> 正常 </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row.value == 'true'"> 报警 </span>
                    <span v-else> 正常 </span>
                  </template>
                </template>
                
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="list">
          <h4>开关量采集单元</h4>
          <el-table :data="deviceData29824" stripe border style="width: 100%">
            <el-table-column prop="monitorName" label="监控点名称">
            </el-table-column>
            <el-table-column label="监控点值">
              <template slot-scope="scope">
                <template
                  v-if="scope.row.value == 'true' || scope.row.value == 'false'"
                >
                  <template>
                    <span v-if="scope.row.value == 'true'"> 离线 </span>
                    <span v-else> 正常 </span>
                  </template>
                </template>
                <span v-else>
                  {{ (+scope.row.value).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDeviceContent, selectDeviceListByCategoryId } from '@/api/business/base/tenant/map'
export default {
  data() {
    return {
      monitor: [11062, 11067],
      deviceData28664: [],
      deviceData28121: [],
      deviceData28122: [],
      deviceData28123: [],
      deviceData28124: [],
      deviceData28663: [],
      deviceData29822: [],
      deviceData29823: [],
      deviceData29824: []
    }
  },
  beforeCreate() {
    getDeviceContent(28664).then(res => {
      this.deviceData28664 = res
    })
    getDeviceContent(28121).then(res => {
      this.deviceData28121 = res.filter(v => +v.monitorType <= 11067 && +v.monitorType >= 11062)
    })
    getDeviceContent(28122).then(res => {
      this.deviceData28122 = res.filter(v => +v.monitorType <= 11067 && +v.monitorType >= 11062)
    })
    getDeviceContent(28123).then(res => {
      this.deviceData28123 = res.filter(v => +v.monitorType <= 11067 && +v.monitorType >= 11062)
    })
    getDeviceContent(28124).then(res => {
      this.deviceData28124 = res.filter(v => +v.monitorType <= 11067 && +v.monitorType >= 11062)
    })
    getDeviceContent(28663).then(res => {
      this.deviceData28663 = res.filter(v => +v.monitorType <= 1002 && +v.monitorType >= 1001)
    })
    selectDeviceListByCategoryId({ categoryId: 19 }).then(res => {
      this.deviceData29822 = res.filter(v => v.deviceId === 29822)[0].monitorList.sort(this.monitorTypeSort)
      this.deviceData29823 = res.filter(v => v.deviceId === 29823)[0].monitorList.sort(this.monitorTypeSort)
      this.deviceData29824 = (res.filter(v => v.deviceId >= 29824 && v.deviceId <= 29829).sort(this.deviceIdSort)).map(v => v.monitorList[0])
    })
  },
  methods: {
    monitorTypeSort(a, b) {
      return +a.monitorType - +b.monitorType
    },
    deviceIdSort(a, b) {
      return +a.deviceId - +b.deviceId
    }
  }
}
</script>

<style lang="scss">
.dongfu-list {
  display: grid;
  grid-template-columns: 460px auto;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  .box-02 {
    .list {
      float: left;

      margin-bottom: 10px;
    }
    .box-02-1 {
      float: left;
      width: 460px;
      margin-right: 10px;
    }
  }
  .list {
    width: 460px;
  }
}
</style>